import { Customer } from "./customer.model";

export class User {
    // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
    constructor(id?: string, userName?: string, fullName?: string, email?: string, jobTitle?: string,
        phoneNumber?: string, roles?: string[], roleId?: string, IsDeleted?: boolean, RegistrationDate?: Date,
        SubscriptionDate?: Date, ExpireDate?: Date, IsTrial?: boolean, IsPermanent?: boolean, IsExtented?: boolean,
        PasswordVerificationKey?: string, PasswordVerificationExpireDate?: Date, customer?: Customer, IsLockedOut?: boolean, LockOutEnd?: Date) {

        this.Id = id;
        this.UserName = userName;
        this.FullName = fullName;
        this.Email = email;
        this.JobTitle = jobTitle;
        this.PhoneNumber = phoneNumber;
        this.Roles = roles;
        this.RoleId = roleId;
        this.IsDeleted = IsDeleted;
        this.RegistrationDate = RegistrationDate;
        this.SubscriptionDate = SubscriptionDate;
        this.ExpireDate = ExpireDate;
        this.IsTrial = IsTrial;
        this.IsPermanent = IsPermanent;
        this.IsExtented = IsExtented;
        this.PasswordVerificationKey = PasswordVerificationKey;
        this.PasswordVerificationExpireDate = PasswordVerificationExpireDate;

        this.Customer = customer;
        this.IsLockedOut = IsLockedOut;
        this.LockOutEnd = LockOutEnd;
    }

    get friendlyName(): string {
        let name = this.FullName || this.UserName;

        if (this.JobTitle)
            name = this.JobTitle + " " + name;

        return name;
    }

    public Id: string;
    public UserName: string;
    public FullName: string;
    public Email: string;
    public JobTitle: string;
    public PhoneNumber: string;
    public IsEnabled: boolean;
    public IsLockedOut: boolean;
    public LockOutEnd?: Date;
    public Roles: string[];
    public RoleId: string;
    public IsDeleted: boolean;

    public RegistrationDate: Date;
    public SubscriptionDate: Date;
    public ExpireDate?: Date;
    public IsTrial: boolean;
    public IsPermanent: boolean;
    public IsExtented: boolean;
    public PasswordVerificationKey: string;
    public PasswordVerificationExpireDate?: Date;


    public Customer: Customer;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/user.model.ts